import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MeetingHistoryLayer from "../components/MeetingHistoryLayer";

const MeetingHistoryPage = () => {
    return (
        <MasterLayout>
            <MeetingHistoryLayer />
        </MasterLayout>
    );
};

export default MeetingHistoryPage;
